const Stack = {
  defaultProps: {
    useFlexGap: true,
    direction: 'row',
  },
};

export default Stack;
